/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={};
if(!window.GS.Toolbar) GS.Toolbar={};
GS.Toolbar.Slider=new Class({
    Extends: GS.BaseClass,
    class_name:'GS.Toolbar.Slider',
    options:{
        'wrapper': null,
        'class':'submenu',
        'property':'unknow',
        'toolbar':null,
        'scale':1,
        'min':0,
        'max':1,
        'step' : 1,
        'disabled':false
    },
    linkedTo:null,
    toolbar:null,
    'ele':null,
    'slider':{ 
        'value': 0,
        'grabber': 0 ,                                                          //this.options.grabber_width*.5,
        'dg':0
    },
    initialize:function(ele,conf){
        this.parent(conf);
        this.addListeners(conf.toolbar);
        this.configure(ele);
    }
});

GS.Toolbar.Slider.prototype.addListeners=function(toolbar){
    
};

/**
 * @deprecated
 * @param {Number} v
 * @param {Boolean} preventDispatch
 **/
GS.Toolbar.Slider.prototype.set=function(v,preventDispatch){
    return;
    v=Math.round(v);
    if(isNaN(v)) v=0;
    //v/=100;
    //this.console.log('Set %s=%s',this.options.property,v/100);
    this.ele.setStyle('background-position',v+'% 50%');
    if(this.slider.x===null) this.slider.value=v;
    if(!preventDispatch) this.fireEvent('change',v/100);
};

/**
 * 
 * @param {type} ele
 * @returns {undefined}
 */
GS.Toolbar.Slider.prototype.configure=function(ele){
    var disabled=this.options.disabled;
    var min=this.options.min;
    var max=this.options.max;
    var scale=max-min;
    var self=this,g,slider,onSlide,setSliderPosition,onSlideEnd;
    this.create(ele);
    var pX=0,perc=0;
    var bar=ele.getElement('.slider-wrapper');
    var grabber=ele.getElement('.grabber');
    //var scale=this.options.scale;
    
    var gDim=grabber.getDimensions();
    //self.console.log(gDim);
    gDim.dX=gDim.width*.5;
    
    this.addEvent('disabled',function(val){
        disabled=val;
        (val) ? ele.setStyle('opacity','0.2') : ele.setStyle('opacity','1');
    });
    
    this.addEvent('scale:update',function(){
        min=this.options.min;
        max=this.options.max;
        scale=max-min;
        //console.debug('Slider update: min=%s, max=%s, scale:%s',min,max,scale);
    });
    
    var data=bar.getCoordinates();
    this.addEvent('set',function(v){
        if(isNaN(v)) v=0;
        vO = v;
        v=(v-min)/scale;
        if(!data || !data.width) data=bar.getCoordinates();
        pX=v*(data.width-gDim.width);
        if(!gDim.dX) {
            gDim=grabber.getDimensions();
            gDim.dX=gDim.width*.5;
           // gDim.dX=gDim.width;
        }

       // pX = (v*data.width) + gDim.dX;
        //this.options.value=v;
       // grabber.setStyle('margin-left',(pX ? pX-gDim.dX : pX)+'px');
        //grabber.setStyle('margin-left',(pX-gDim.width*.5)+'px');

        grabber.setStyle('margin-left',(pX)+'px');

        data=null;
        if(this.inputField){
            this.inputField.setValue(Number(vO));
        }
        //console.log('Set perperty %s to %s --->pX',self.options.property,v,pX,bar.getDimensions());
    });
    
    var onSlide=function(e){
        pX=e.event.clientX-(gDim.width*.5)-data.left;
        
        perc=pX/(data.width-gDim.width);
        
        if(!gDim.dX) {
            gDim=grabber.getDimensions();
            gDim.dX=gDim.width*.5;
            //gDim.dX=gDim.width;
        }

        //perc=pX/(data.width-gDim.dX);
        //console.log(perc);
        if(perc>=1) {
            perc=1;
            pX= data.width-gDim.width;
        }
        if(perc<=0){
            perc=0;
            pX=0;
        }

        //pX = (v*data.width) + gDim.dX;
        
        //self.console.log(grabber.getDimensions());
        //self.set(perc);
        
        //console.debug(min+perc*scale);
        
        //grabber.setStyle('margin-left',(pX-gDim.width*.5)+'px');
        //grabber.setStyle('margin-left',(pX)+'px');
        grabber.setStyle('margin-left',(pX)+'px');
        //self.console.log(perc);
        self.fireEvent('change',min+(perc*scale));
    };
    
    var onSlideEnd=function(e){
        e.stop();
        e.preventDefault();
        self.fireEvent('end');
        data=null;
        window.removeEvents({'mousemove':onSlide,'mouseup':onSlideEnd});
    };
    
    this.slider.x=null;
    this.slider.y=null;
    
    //Add slider main event
    bar.addEvents({
        'mousedown' : function(e){
            if(e){
                e.stop();
                e.preventDefault();
            }
            if(disabled) return;
            var update=!e.target.hasClass('grabber');
            if(!data || !data.width) data=this.getCoordinates();
            self.fireEvent('start');
            if(update) onSlide(e);
            window.addEvents({'mousemove':onSlide,'mouseup':onSlideEnd});
        },
        'click':function(e){
            if(e){
                e.stop();
                e.preventDefault();
            }
            self.fireEvent('start');
            if(disabled) return;
            var update=!e.target.hasClass('grabber');
            if(!data || !data.width) data=this.getCoordinates();
            if(update) onSlide(e);
        }     
                
    });
    
    var pX=this.options.value*(data.width-gDim.width);
    data=null;
    //grabber.setStyle('margin-left',(pX-gDim.width*.5)+'px');

    grabber.setStyle('margin-left',(pX)+'px');
    //self.set(this.options.value,true);
    
};

GS.Toolbar.Slider.prototype.create=function(ele){
    ele.adopt(new Element('div',{'class':'slider-wrapper'}).set('html','<div class="grabber"></div>'));
   
};

GS.Toolbar.Slider.prototype.setMinMax=function(min,max, step){
    this.options.min=min;
    this.options.max=max;
    this.fireEvent('scale:update');
    if(this.inputField){
        if(step) this.options.step = Number(step);
        this.inputField.setMinMax(this.options.min,this.options.max, this.options.step);
    }
};